export default __webpack_public_path__ + "static/media/scroll-logo.d962c036.svg";